import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import PageSEO from '../../components/SEO/PageSEO';

const MentionsLegales = () => {
  // Schéma JSON-LD pour la page mentions légales
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Mentions légales - Comprendre les SES",
    "description": "Mentions légales du site Comprendre les SES, informations sur l'éditeur, l'hébergement et les droits de propriété intellectuelle.",
    "publisher": {
      "@type": "Organization",
      "name": "Comprendre les SES",
      "logo": "https://cours-ses.fr/Logo SES.png"
    },
    "license": "https://cours-ses.fr/mentions-legales"
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageSEO
        title="Mentions légales - Comprendre les SES"
        description="Mentions légales du site Comprendre les SES, informations sur l'éditeur, l'hébergement et les droits de propriété intellectuelle."
        path="/mentions-legales"
        image="https://cours-ses.fr/Logo SES.png"
        schema={schema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-[#323c5f] mb-8">Mentions Légales</h1>
            
            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">1. Identité et coordonnées</h2>
                <p className="mb-4">
                  Le site "Comprendre les SES" (https://cours-ses.fr) est édité par Brandon et Marion, auto-entrepreneurs.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="mb-2"><strong>Siège social :</strong> 2 Avenue Antoine de Saint-Exupéry, Bât Les Lauriers 1, 84400 Apt, France</p>
                  <p className="mb-2"><strong>Email :</strong> comprendrelessespro@gmail.com</p>
                  <p className="mb-2"><strong>SIRET :</strong> 949 911 713 00038</p>
                  <p><strong>Numéro de TVA intracommunautaire :</strong> Non assujetti à la TVA</p>
                </div>
                <p className="mt-4">
                  <strong>Directeurs de la publication :</strong> Brandon MAESTU et Marion MOREAU
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">2. Hébergement</h2>
                <p>
                  Le site "Comprendre les SES" (https://cours-ses.fr) est hébergé par :<br />
                  OVH SAS, filiale de la société OVH Groupe SA
<br />
                  2 rue Kellermann<br />
                  59100 Roubaix<br />
                  France
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">3. Propriété intellectuelle</h2>
                <p className="mb-4">
                  L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, mise en page, base de données, etc.) est protégé par le droit d'auteur et le droit des marques.
                </p>
                <p className="mb-4">
                  Toute reproduction, représentation, modification, publication, adaptation ou exploitation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Brandon MAESTU et Marion MOREAU.
                </p>
                <p className="mb-4">
                  Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
                </p>
                <p>
                  Pour toute demande d'autorisation ou d'information, veuillez nous contacter à l'adresse : comprendrelessespro@gmail.com
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">4. Données personnelles</h2>
                <p className="mb-4">
                  Les informations recueillies sur ce site sont traitées conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
                </p>
                <p className="mb-4">
                  Nous collectons et traitons vos données personnelles dans le cadre de notre activité commerciale et pédagogique. Ces données sont nécessaires pour :
                </p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Vous permettre d'accéder à nos services</li>
                  <li>Traiter vos commandes et réservations</li>
                  <li>Vous envoyer des informations relatives à nos produits et services</li>
                  <li>Améliorer notre offre et votre expérience utilisateur</li>
                </ul>
                <p className="mb-4">
                  Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition concernant vos données personnelles. Pour exercer ces droits, veuillez nous contacter à l'adresse : comprendrelessespro@gmail.com
                </p>
                <p>
                  Pour plus d'informations sur la gestion de vos données personnelles, veuillez consulter notre <a href="/confidentialite" className="text-[#9a6ebd] hover:underline">Politique de Confidentialité</a>.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">5. Cookies</h2>
                <p className="mb-4">
                  Le site "Comprendre les SES" (https://cours-ses.fr) utilise des cookies pour améliorer l'expérience utilisateur, analyser le trafic et personnaliser le contenu. En naviguant sur notre site, vous acceptez l'utilisation de cookies conformément à notre politique de confidentialité.
                </p>
                <p>
                  Vous pouvez configurer votre navigateur pour refuser les cookies ou être alerté lorsque des cookies sont envoyés. Veuillez noter que certaines fonctionnalités du site pourraient ne plus être disponibles si vous désactivez les cookies.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">6. Limitation de responsabilité</h2>
                <p className="mb-4">
                  Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement mis à jour. Cependant, des erreurs ou omissions peuvent survenir. L'utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
                </p>
                <p className="mb-4">
                  "Comprendre les SES" ne pourra être tenu responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation de ce site, y compris l'inaccessibilité, les pertes de données, dommages, destructions ou virus qui pourraient affecter votre équipement informatique, et/ou de la présence de virus sur son site.
                </p>
                <p className="mb-4">
                  Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de "Comprendre les SES".
                </p>
                <p>
                  "Comprendre les SES" se réserve le droit de modifier le contenu de ce site à tout moment et sans préavis.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">7. Droit applicable et juridiction compétente</h2>
                <p className="mb-4">
                  Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
                <p>
                  Pour toute question relative à l'application des présentes mentions légales, vous pouvez nous contacter à l'adresse : comprendrelessespro@gmail.com
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">8. Médiation de la consommation</h2>
                <p className="mb-4">
                  Conformément aux dispositions du Code de la consommation concernant le règlement amiable des litiges, vous pouvez recourir au service de médiation proposé par "Comprendre les SES". Le médiateur "droit de la consommation" ainsi proposé est MEDICYS.
                </p>
                <p>
                  Ce dispositif de médiation peut être joint par voie électronique : www.medicys.fr, ou par voie postale : MEDICYS - Centre de médiation et règlement amiable des huissiers de justice - 73, Boulevard de Clichy, 75009 Paris.
                </p>
              </section>

              <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mt-8">
                <h3 className="text-lg font-semibold text-blue-800 mb-2">Information importante</h3>
                <p className="text-blue-700">
                  Le non-respect des dispositions légales applicables aux sites internet, notamment en matière de mentions légales, peut entraîner des sanctions pénales et financières. Ces mentions légales sont donc essentielles pour assurer la conformité de votre site avec la législation en vigueur.
                </p>
              </div>

              <p className="text-sm text-gray-500 text-right mt-8">
                Dernière mise à jour : 27 février 2025
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;